<interacta-dialog [isOpen]="visible()" [size]="'regular'" (closing)="close()">
    @let community = community$ | async;
    @let _hashtag = hashtag();
    <!-- Title -->
    <ng-container title>
        @if (_hashtag && community) {
            <h2 class="line-clamp-1 typo-t5 break-all">#{{ _hashtag.name }}</h2>
        } @else {
            <section class="m-auto flex h-200 items-center">
                <interacta-loader [size]="'large'" />
            </section>
        }
    </ng-container>

    <!-- Content -->
    <ng-container content>
        @if (_hashtag && community?.metadata?.hashTagEnabled) {
            <p class="mb-16 typo-sm">
                {{
                    _hashtag.count
                        | i18nPlural
                            : {
                                  '=1': 'HASHTAG_INFO.COUNT_IN_COMMUNITY_SING',
                                  other: 'HASHTAG_INFO.COUNT_IN_COMMUNITY_PLUR',
                              }
                        | translate
                            : {
                                  count: _hashtag.count,
                                  community: community?.name,
                              }
                }}
            </p>

            <!-- Follow/unfollow button -->
            @if (!_hashtag.deleted) {
                <button
                    class="mb-16"
                    interacta-toggle-button
                    type="button"
                    [icon]="'bell'"
                    [label]="
                        (_hashtag.followedByMe
                            ? 'HASHTAG_INFO.ALREADY_FOLLOWING'
                            : 'HASHTAG_INFO.FOLLOW'
                        ) | translate
                    "
                    [selected]="_hashtag.followedByMe ?? false"
                    (click)="$event.stopPropagation(); toggleFollow(_hashtag)"
                ></button>
            }

            <interacta-separator class="mb-8 block" [thickness]="'strong'" />

            <!-- Search type selection -->
            <p class="typo-sm-bold">
                {{ 'HASHTAG_INFO.SEARCH' | translate }}
            </p>
            @if (community.metadata.attachmentEnabled) {
                <interacta-radio-group [formControl]="searchType">
                    <interacta-radio-button [value]="'post'">
                        {{ 'HASHTAG_INFO.SEARCH_TYPE.POST' | translate }}
                    </interacta-radio-button>
                    <interacta-radio-button [value]="'attachment'">
                        {{ 'HASHTAG_INFO.SEARCH_TYPE.ATTACHMENT' | translate }}
                    </interacta-radio-button>
                    <interacta-radio-button [value]="'both'">
                        {{ 'HASHTAG_INFO.SEARCH_TYPE.BOTH' | translate }}
                    </interacta-radio-button>
                </interacta-radio-group>
            } @else {
                <interacta-checkbox-group
                    class="mt-12"
                    [formControl]="searchType"
                >
                    <interacta-checkbox [value]="'post'">
                        {{ 'HASHTAG_INFO.SEARCH_TYPE.POST' | translate }}
                    </interacta-checkbox>
                </interacta-checkbox-group>
            }

            <!-- Apply / cancel buttons -->
            <interacta-dialog-buttons>
                <button
                    interacta-dialog-button
                    type="button"
                    [label]="
                        'BUTTON.LABEL_BUTTON_CANCEL'
                            | translate: { hashtag: _hashtag.name }
                    "
                    [style]="'text'"
                    (click)="close()"
                ></button>
                <button
                    interacta-dialog-button
                    type="button"
                    [label]="'BUTTON.LABEL_BUTTON_APPLY' | translate"
                    [style]="'filled'"
                    (click)="apply(_hashtag, searchType.value, community)"
                ></button>
            </interacta-dialog-buttons>
        } @else if (community) {
            <!-- Content in case of disabled hashtags in community -->
            <p>
                {{ 'HASHTAG_INFO.DISABLED_COMMUNITY' | translate }}
            </p>
            <interacta-dialog-buttons>
                <button
                    interacta-dialog-button
                    type="button"
                    [label]="'HASHTAG_INFO.UNDERSTOOD' | translate"
                    [style]="'filled'"
                    (click)="close()"
                ></button>
            </interacta-dialog-buttons>
        }
    </ng-container>
</interacta-dialog>
